// extracted by mini-css-extract-plugin
var _1 = "Numeration_closeIcon__f97c0";
var _2 = "Numeration_numberWrapper__3aa27";
var _3 = "Numeration_selectedIndexBlock__fbe57";
var _4 = "Numeration_valueText__5acbf";
export { _1 as "closeIcon", _2 as "numberWrapper", _3 as "selectedIndexBlock", _4 as "valueText" }
